import localDB from "./localDB";

let GLOBAL = require('./globals');

const RecipeData = {
    async add(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/recipes`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(err));
    },
    async delete(id, res) {
        await fetch(`${GLOBAL.BASE_URL}api/recipes/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async update(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/recipes/${data.id}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(err));
    },
    async getAll(res) {
        await fetch(`${GLOBAL.BASE_URL}api/recipes-all`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(err));
    },
};

export default RecipeData;



// WEBPACK FOOTER //
// ./src/data/RecipeData.js